import script from "./AccessRequestsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessRequestsManager.vue?vue&type=script&setup=true&lang=js"

import "./AccessRequestsManager.vue?vue&type=style&index=0&id=6a52ddca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a52ddca"]])

export default __exports__